var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leftBar" },
    [
      _c("v-drawer", { attrs: { direction: "left", width: "26%" } }, [
        _c(
          "div",
          { staticClass: "animated fadeInLeftBig dx" },
          [
            _c(
              "left-card",
              { staticClass: "lefts", attrs: { bg: "border1" } },
              [
                _c("v-title", [_vm._v("园区概况")]),
                _c(
                  "div",
                  { staticClass: "panelContent" },
                  [
                    _c("left-top"),
                    _c("left-mid"),
                    _c("left-bot"),
                    false ? _c("left-xs") : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "bar-card",
              { staticClass: "lefts lefts2", attrs: { bg: "border2" } },
              [
                _c("v-title", [_vm._v("联农带农")]),
                _c(
                  "div",
                  { staticClass: "panelContent" },
                  [_c("left-lndn")],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }